export function pluralize (word, amount) {
  return (amount > 1 || amount === 0) ? `${word}s` : word
}

export function capitalize (word) {
  return word.toUpperCase()
}

export function intensityColor (val) {
  switch (val) {
    case 'High':
      return 'red'
    case 'Medium':
      return 'blue'
    case 'Low':
      return 'green'
  }
}

export function iconifyTask (val) {
  switch (val) {
    case 'mobility':
      return 'filter_drama'
    case 'warmup':
      return 'whatshot'
    case 'oly':
      return 'fitness_center'
    case 'weight':
      return 'fitness_center'
    case 'gym':
      return 'accessibility'
    case 'cardio':
      return 'directions_run'
    default:
      return 'fitness_center'
  }
}



// WEBPACK FOOTER //
// ./src/filters/index.js